<template>
    <div class="d-flex justify-start align-center gap-2" style="gap: 8px">
        <template v-if="!isParamDate">
            <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs" class="button-picker" elevation="0" style="padding: 10px !important">
                        <svg xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="0 0 24 24">
                            <path
                                d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z" />
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24">
                            <path d="M7,10L12,15L17,10H7Z" />
                        </svg>
                    </v-btn>
                </template>
                <v-date-picker v-model="date" range :min="minDtae" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false"> {{ $t('text_cancel') }} </v-btn>
                    <v-btn text color="primary" @click="handleOK"> OK </v-btn>
                </v-date-picker>
            </v-dialog>
        </template>

        <div class="day-buttons scroll-horizontal">
            <v-btn v-for="(day, index) in days" :key="index" @click="selectDate(day)"
                :class="`${day.date === selectedDay?.date ? 'selected-day' : ''} ${day?.is_closing_dates || day?.can_not_be_used ? 'disabled' : ''}`"
                class="button-picker" elevation="0">
                <div class="picker">
                    <span class="text-caption">{{ day.date_day }} {{ day.date_month }}</span>
                    <span>{{ today === day.date ? $t('text_today') : day.day_name }}</span>
                </div>
            </v-btn>
        </div>
    </div>
</template>

<script>
import { getReserVationTime } from '@/api/reservation-time'
export default {
    props: {
        onchange: Function,
        defaultListDay: Array,
        defaultDay: Object || null,
        layout_id: Number,
        isFloorChange: Boolean,
    },

    data() {
        const urlParams = new URLSearchParams(window.location.search);
        const dateParam = urlParams.get('date');
        
        let startDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
        let endDate = new Date(startDate);

        if (dateParam) {
            startDate = new Date(dateParam);
            endDate = new Date(dateParam);
        }
        endDate.setDate(startDate.getDate() + 5);

        return {
            date: [
                startDate.toISOString().substr(0, 10),
                endDate.toISOString().substr(0, 10),
            ],
            minDtae: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            modal: false,
            days: [],
            selectedDay: null,
            today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            isParamDate: dateParam ? true : false
        };
    },

    watch: {
        defaultDay(newDefaultDay) {
            this.selectedDay = newDefaultDay;
        },
        defaultListDay(newDefaultListDay) {
            this.days = newDefaultListDay;
        },
        layout_id(newLayoutId) {
            this.generateDays(newLayoutId);
        },
    },

    methods: {
        getFirstStartTimeAndLastEndTime(times) {
            if (times.length === 0) {
                return { firstStartTime: null, lastEndTime: null };
            }

            const firstStartTime = times[0].fstart_time;
            const lastEndTime = times[times.length - 1].fend_time;

            return { firstStartTime, lastEndTime };
        },
        async generateDays(layout_id) {
            const listCart = this.$store.getters.dataCartReservation;
            const starDate = this.date[0];
            const endDate = this.date.length > 1 ? this.date[1] : starDate;
            try {
                const { data } = await getReserVationTime({
                    start_date: starDate,
                    end_date: endDate,
                    show_times: 1,
                    resto_layout_id: layout_id || this.layout_id,
                }).then((res) => res.data);

                this.days = data;
                console.log('cek days', this.defaultDay);
                if (this.defaultDay) {
                    this.triggerSelectedDate(this.defaultDay);
                } else if (data.length > 0) {
                    if (listCart.length > 0 && !this.isFloorChange) {
                        const findAlreadyIncart = data.find((item) => item.date === listCart[0].reservation_date.date);
                        findAlreadyIncart && this.triggerSelectedDate(findAlreadyIncart)
                    } else {
                        this.triggerSelectedDate(data[0]);
                    }
                }
            } catch (e) {
                this.$store.state.show_error = true;
                this.$store.state.error_message = e.data.message
                this.$store.state.error_type = e.statusCode;
            }
        },

        selectDate(day) {
            this.triggerSelectedDate(day);
        },
        triggerSelectedDate(day) {
            this.selectedDay = day;
            const startTimeAndEndTime = this.getFirstStartTimeAndLastEndTime(day?.times);
            if (typeof this.onchange === "function") {
                this.onchange(day, startTimeAndEndTime);
            }
        },
        handleOK() {
            this.$refs.dialog.save(this.date);
            this.modal = false;
            this.generateDays();
        },
    },
};
</script>

<style>
.day-buttons {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding-right: 8px;
}

.button-picker.selected-day {
    background-color: #1976d2 !important;
    border-color: #1976d2 !important;
    color: #fff !important;
}

.button-picker.disabled {
    background-color: #EEEEEE !important;
    border-color: #cecece !important;
    color: #767676 !important;
}

.button-picker.selected-day.disabled {
    background-color: #5b5b5b !important;
    border-color: #5b5b5b !important;
    color: #cecece !important;
}

.scroll-horizontal {
    overflow-x: auto;
    white-space: nowrap;
}

.button-picker {
    height: 55px !important;
    text-transform: capitalize !important;
    border: 1px solid #cecece !important;
    background-color: #fff !important;
    border-radius: 8px !important;
    padding-bottom: 8px !important;
}

.picker {
    display: flex;
    flex-direction: column;
}
</style>
